
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rolam",
      function () {
        return require("private-next-pages/rolam/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rolam"])
      });
    }
  